import { createGlobalStyle } from 'styled-components'
import {
  mediaMax,
  mediaMin,
  calculateResponsiveSize,
  calculateMobileResponsiveSize
} from 'styles/media-queries'

const GlobalStyle = createGlobalStyle`
  :root {
    --Warm-White: #FFFFFF;
    --Charcoal: #464946;
    --Terracotta: #864A33;
    --Gray: #859587;
  }
  html, body{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    font-size: 14px;
    color: var(--Charcoal);
    line-height: 1.25;
    background: var(--Warm-White);
    min-width: 320px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-feature-settings: "liga" 1;
  }
  body{
    overflow-y: scroll;
  }
  html:has(body.menu-opened),
  body.menu-opened {
    background: var(--Terracotta);
  }
  body.hidden {
    height: 100dvh !important;
  }
  ${mediaMax('mobile')} {
    body.hidden {
      overflow: hidden;
    }
  }
  body.hidden .home-wrapper {
    height: 100dvh;
    overflow: hidden;
  }
  html, body, A, input, select, textarea, button{
    font-family: 'Graphik', Arial, Tahoma, Geneva, Kalimati, sans-serif;
  }
  A{
    text-decoration: none;
    color: var(--Charcoal);
    outline: none;
  }
  A:hover{
    text-decoration: underline;
  }
  input, select, textarea {
    vertical-align: top;
    outline: none;
  }
  button {
    outline: none;
  }
  ul,li,h3,h2,p{
    margin: 0;
    padding: 0;
  }
  /* ----- Safari profile icon ----- */
  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  textarea {
    resize: vertical;
  }
  *{ -webkit-tap-highlight-color: transparent; box-sizing: border-box; }
  img, object, iframe, svg{ border: 0; vertical-align: top; }
  button { font-weight: 400; }
  ${mediaMin('mobile')} {
    .home-content {
      will-change: transform; 
    }
  }
  div.architecture-page {
    background: var(--Terracotta);
  }

  /* ----- UserWay ----- */
  body .uwy {
    opacity: 1;
    visibility: visible;
    transition: opacity 2s, visibility 2s;
    z-index: 50 !important;
    &.hide {
      opacity: 0;
      visibility: hidden;
      transition: opacity 0s, visibility 0s;
    }
  }
  body .uwy > .userway_buttons_wrapper  {
    top: auto !important;
    bottom: ${calculateResponsiveSize(30)} !important;
    left: ${calculateResponsiveSize(35)} !important;
    right: auto !important;
    transform: none !important;
  }
  body .uwy .uai, body .uwy .uai > span {
    width: ${calculateResponsiveSize(40)} !important;
    height: ${calculateResponsiveSize(40)} !important;
  }
  body .uwy .uai > span > img {
    width: 100% !important;
    height: auto !important;
  }
  ${mediaMax('mobile')} {
    body .uwy > .userway_buttons_wrapper  {
      bottom: ${calculateMobileResponsiveSize(20)} !important;
      left: ${calculateMobileResponsiveSize(20)} !important;
    }
    body .uwy .uai, body .uwy .uai > span {
      width: ${calculateMobileResponsiveSize(40)} !important;
      height: ${calculateMobileResponsiveSize(40)} !important;
    }
  }

  /* ----- Registered Symbol ----- */
  sup {
    /* font-size: 0.4em; */
    position: relative;
    top: 0.3em;
    &.tm {
      font-size: 0.6em;
      top: 0;
    }
  }

  /* ----- For gallery ----- */
  .portal {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 103;
    display: flex;
    justify-content: center;
  }

  /* ----- Formatting ----- */
  .h1{
    font-family: "Didot";
    font-size: ${calculateResponsiveSize(60)};
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: ${calculateResponsiveSize(-1.2)};
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(40)};
      letter-spacing: ${calculateMobileResponsiveSize(-0.8)};
    }
  }
  .h3{
    font-family: "Graphik";
    font-size: ${calculateResponsiveSize(12)};
    font-weight: 600;
    line-height: 1.6;
    text-transform: uppercase;
    letter-spacing: ${calculateResponsiveSize(0.36)};
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(12)};
      letter-spacing: ${calculateMobileResponsiveSize(0.36)};
    }
  }
  .h2{
    font-family: "Didot";
    letter-spacing: -${calculateResponsiveSize(0.6)};
    font-size: ${calculateResponsiveSize(30)};
    font-weight: 400;
    line-height: 1.2;
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(24)};
      letter-spacing: -${calculateMobileResponsiveSize(0.48)};
    }
  }
  .h4{
    font-family: "Graphik";
    font-size: ${calculateResponsiveSize(12)};
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: ${calculateResponsiveSize(0.6)};
    text-transform: uppercase;
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(12)};
      letter-spacing: ${calculateMobileResponsiveSize(0.6)};
    }
  }  
  .t1{
    font-family: "Graphik";
    font-size: ${calculateResponsiveSize(14)};
    font-weight: 400;
    line-height: 1.6;
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(14)};
    }
  }
  .t2{
    font-family: "Graphik";
    font-size: ${calculateResponsiveSize(12)};
    font-weight: 400;
    line-height: 1.6;
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(12)};
    }
  }
  .c1{
    font-family: "Graphik";
    font-size: ${calculateResponsiveSize(10)};
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: ${calculateResponsiveSize(1)};
    text-transform: uppercase;
    ${mediaMax('mobile')} {
      font-size: ${calculateMobileResponsiveSize(10)};
      letter-spacing: ${calculateMobileResponsiveSize(1)};
    }
  }

  .mob-only{
    display: none !important;
  }
  ${mediaMax('mobile')} {
    .web-only{
      display: none !important;
    }
    .mob-only{
      display: block !important;
    }
  }

  /* ----- reCAPTCHA: badge hidden; attribution shown inside the form ----- */
  .grecaptcha-badge {
    visibility: hidden;
  }
`

export default GlobalStyle
